import { animations, palette } from '../../../theme';

export const desktopDtgApolloTopCardsStyles = {
  topCardsDesktopWrapper: {
    gap: '16px',
    ...animations.appearanceEffect,
  },

  cardWrapperBase: {
    background: palette.background.paper,
    border: `1px solid ${palette.grey[200]}`,
    borderRadius: '8px',
    ...animations.appearanceEffect,
  },

  totalImpressionCardWrapper: {
    background: palette.background.paper,
    border: `1px solid ${palette.grey[200]}`,
    borderRadius: '8px',
    ...animations.appearanceEffect,
    width: 'clamp(202px, 25%, 25%)',
    minWidth: '202px',
  },

  //*wider variant for Production Hours mode - the card carries an extra "Total Impressions" metric next to the primary value.
  //*Widths across the row must add up to <=96% (the remaining ~4% covers the 16px gaps): 30 + 16 + 25 + 25.
  totalImpressionCardWrapperProductionMode: {
    background: palette.background.paper,
    border: `1px solid ${palette.grey[200]}`,
    borderRadius: '8px',
    ...animations.appearanceEffect,
    width: 'clamp(360px, 30%, 30%)',
    minWidth: '360px',
  },

  averageProductionRateCardWrapper: {
    background: palette.background.paper,
    border: `1px solid ${palette.grey[200]}`,
    borderRadius: '8px',
    ...animations.appearanceEffect,
    width: '25%',
    minWidth: '344px',
  },

  //*narrower variant for Production Hours mode - this card has no added-data grey block, so it can give up width to the wider Total Impressions card without losing content
  averageProductionRateCardWrapperProductionMode: {
    background: palette.background.paper,
    border: `1px solid ${palette.grey[200]}`,
    borderRadius: '8px',
    ...animations.appearanceEffect,
    width: 'clamp(200px, 16%, 16%)',
    minWidth: '200px',
  },

  productivityCardWrapper: {
    background: palette.background.paper,
    border: `1px solid ${palette.grey[200]}`,
    borderRadius: '8px',
    ...animations.appearanceEffect,
    width: '25%',
    minWidth: '304px',
  },

  averageAvailabilityCardWrapper: {
    background: palette.background.paper,
    border: `1px solid ${palette.grey[200]}`,
    borderRadius: '8px',
    ...animations.appearanceEffect,
    width: '25%',
    minWidth: '296px',
  },

  //*Production Hours mode: the row sums to 96%, so the last two cards absorb the leftover width and the row ends flush with the content below
  productivityCardWrapperProductionMode: {
    background: palette.background.paper,
    border: `1px solid ${palette.grey[200]}`,
    borderRadius: '8px',
    ...animations.appearanceEffect,
    width: '25%',
    minWidth: '304px',
    flexGrow: 1,
  },

  averageAvailabilityCardWrapperProductionMode: {
    background: palette.background.paper,
    border: `1px solid ${palette.grey[200]}`,
    borderRadius: '8px',
    ...animations.appearanceEffect,
    width: '25%',
    minWidth: '296px',
    flexGrow: 1,
  },
};
